import { analytics } from '@/features/analytics/service';

export function trackNotFoundPageViewed(pathname: string): void {
  analytics.captureEvent('Not Found Page Viewed', { pathname });
}
